module.exports = __webpack_public_path__ + "fonts/MaterialIconsOutlined-Regular.19dad0be.otf";